import { normalizeCitySearchQuery } from '../utils';
import { CityResponseData } from './models';

export const getCitySearchResults = async (query: string): Promise<Array<CityResponseData>> => {
    // Normalize here too, so direct API callers do not send whitespace/case variants.
    const normalizedQuery = normalizeCitySearchQuery(query);
    const searchParams = new URLSearchParams({ query: normalizedQuery });
    const response = await fetch(
        `/api/integrations/address-postcodes/search?${searchParams.toString()}`,
    );

    if (!response.ok) {
        throw new Error(`City search failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
};
